<section class="patient-space vc-view-shell">
  <main class="patient-space__main vc-view-content">

    <article class="patient-space__content vc-surface-panel vc-surface-panel--padded">
      <router-outlet></router-outlet>
    </article>
  </main>
</section>